import { render } from "./WearableData.vue?vue&type=template&id=5e95623c"
import script from "./WearableData.vue?vue&type=script&lang=js"
export * from "./WearableData.vue?vue&type=script&lang=js"

import "./WearableData.vue?vue&type=style&index=0&id=5e95623c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__